import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';
import { fieldClass } from './variants.ts';

/**
 * Auswahlfeld (natives `select`) im Aussehen des Formularfelds (`fieldClass`, Ticket 1.256): weiß mit klarem Rand, Fokus blau
 * mit 2 px Rand; `disabled` sieht gesperrt aus. Ohne Browser-Pfeil, mit eigenem Pfeil in der Token-Farbe `--chevron`
 * (hell/dunkel, Utility `select-chevron`; Ticket 1.215). Wurzel bleibt das `select`, damit sich an den Nutzern nichts
 * am Layout ändert.
 */
export function Select({ className, invalid, ...props }: ComponentProps<'select'> & { invalid?: boolean }) {
  const locked = !!props.disabled;
  return (
    <select
      aria-invalid={invalid || undefined}
      data-field-box={locked ? 'locked' : 'edit'}
      className={cn(fieldClass({ invalid, locked }), 'select-chevron h-11 w-full pr-[var(--field-end-icon)] pl-space-4', locked ? undefined : 'cursor-pointer', className)}
      {...props}
    />
  );
}
